export default class YouTubePlaylist {
	constructor(apiKey, selector = '[data-youtube-playlist]') {
		this.apiKey = apiKey || (this.container ? this.container.dataset.api_key : null);
		this.container = document.querySelector(selector);
	}
	
	render(options = {}) {
		const {
			playlist,
			maxVideos = 6,
			columns = 2,
			showCaptions = true
		} = options;
		
		this.playlist = playlist || (this.container ? this.container.dataset.playlist : null);
		this.maxVideos = maxVideos;
		this.columns = columns;
		this.showCaptions = showCaptions;
		
		this.apiUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${this.maxVideos}&playlistId=${this.playlist}&key=${this.apiKey}`;
		
		fetch(this.apiUrl).then(res => res.json()).then(data => {
			data.items.forEach(item => {
				const colClass = `col-md-${Math.floor(12 / this.columns)}`;
				const video = item.snippet;
				const iframeUrl = `https://www.youtube-nocookie.com/embed/${video.resourceId.videoId}`;
				
				this.container.insertAdjacentHTML('beforeend', `
					<div class="${colClass}">
						<div class="embed-responsive embed-responsive-16by9 mb-2">
							<iframe class="embed-responsive-item" src="${iframeUrl}" title="${video.title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
						</div>
						${this.showCaptions ? `<p>${video.title}</p>` : ''}
					</div>`
				);
			});
		});
	}
}
